import { ShieldCheck } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

const policies = [
  "Uso obligatorio de arnés o transportadora durante todo el trayecto.",
  "Tu mascota debe contar con vacunas al día (rabia y refuerzos vigentes).",
  "No transportamos mascotas con enfermedades infecciosas activas.",
  "Debes informar cualquier condición médica o de comportamiento relevante.",
  "El vehículo se sanitiza entre cada viaje; llevamos agua fresca y mantita.",
  "Cancelaciones o cambios con al menos 2 horas de anticipación por WhatsApp.",
];

export function SafetyPolicyModal() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type="button"
          className="font-extrabold text-primary underline underline-offset-2 transition-colors hover:text-gold-deep"
        >
          Ver políticas de seguridad
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-lg rounded-[1.75rem]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display text-xl font-bold text-primary">
            <ShieldCheck className="h-5 w-5 text-gold-deep" aria-hidden />
            Términos de Servicio y salud
          </DialogTitle>
          <DialogDescription>
            Reglas que mantienen a tu peludo seguro en cada viaje PetMoon.
          </DialogDescription>
        </DialogHeader>
        <ul className="mt-2 space-y-3 text-sm font-semibold text-foreground">
          {policies.map((p) => (
            <li key={p} className="flex items-start gap-2.5">
              <span
                aria-hidden
                className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent"
              />
              {p}
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
